import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPartners,
  deletePartner,
} from "../../../redux/partnerSlice";
import Sidebar from "../Sidebar";
import PartnerForm from "./PartnersForm";
import { toast } from "react-toastify";

const AdminPartnersPage = () => {
  const dispatch = useDispatch();
  const { partners = [], loading, error } = useSelector((state) => state.partners || {});
  const [editMode, setEditMode] = useState(false);
  const [currentPartner, setCurrentPartner] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    dispatch(fetchPartners());
  }, [dispatch]);

  const handleEdit = (partner) => {
    setEditMode(true);
    setCurrentPartner(partner);
    setIsPopupOpen(true);
  };

  const handleDelete = (id) => {
    dispatch(deletePartner(id))
      .unwrap()
      .then(() => toast.success("Partner deleted successfully"))
      .catch(() => toast.error("Failed to delete team partner"));
  };

  const handleAddPartner = () => {
    setEditMode(false);
    setCurrentPartner(null);
    setIsPopupOpen(true);
  };

  return (
    <div className="flex">
      {/* Sidebar */}
      <Sidebar />
      {/* Main Content */}
      <div className="flex-1 p-8">
        <h1 className="text-2xl font-bold mb-6">Partner Management</h1>

        <button
          onClick={handleAddPartner}
          className="bg-green-500 text-white px-4 py-2 rounded mb-6"
        >
          Add Partner
        </button>

        {/* Display Partners */}
        {loading && <p>Loading Partner...</p>}
        {error && <p className="text-red-500">{error}</p>}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {partners.map((partner) => (
            <div
              key={partner.id}
              className="bg-white p-4 rounded-lg shadow flex flex-col items-center"
            >
              <img
                src={partner.imageUrl}
                alt={partner.names}
                className="w-24 h-24 object-cover rounded-full mb-4"
              />
              <h2 className="text-lg font-semibold">{partner.names}</h2>
              <p className="text-sm text-gray-600">{partner.names}</p>
              <div className="mt-4 flex gap-2">
                <button
                  onClick={() => handleEdit(partner)}
                  className="bg-blue-500 text-white px-4 py-2 rounded-md"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(partner.id)}
                  className="bg-red-500 text-white px-4 py-2 rounded-md"
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Popup Form */}
      {isPopupOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <button
              className="text-gray-500 hover:text-gray-800 absolute top-4 right-4"
              onClick={() => setIsPopupOpen(false)}
            >
              &times;
            </button>
            <PartnerForm
              editMode={editMode}
              existingPartner={currentPartner}
              onClose={() => {
                setIsPopupOpen(false);
                setEditMode(false);
                setCurrentPartner(null);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminPartnersPage;
